export const InputStyle = {
  baseStyle: {
    field: {
      background: 'transparent',
      borderColor: 'brand.border',
      borderWidth: '1px',
      borderRadius: '6px',
      fontSize: '15px',
      ':hover': { borderColor: 'brand.text.muted' },
      ':focus': { borderColor: 'brand.primary', borderWidth: '2px' },
    },
  },
  sizes: {},
  variants: {},
  defaultProps: { variant: null },
};

export const SelectStyle = {
  baseStyle: {
    field: {
      background: 'transparent',
      borderColor: 'brand.border',
      borderWidth: '1px',
      borderRadius: '6px',
      ':hover': { borderColor: 'brand.text.muted' },
      ':focus': { borderColor: 'brand.primary', borderWidth: '2px' },
    },
  },
  sizes: {},
  variants: {},
  defaultProps: { variant: null },
};

export const RadioStyle = {
  baseStyle: {
    field: {
      background: 'transparent',
      borderColor: 'brand.border',
      borderWidth: '1px',
      focusBorderColor: 'accent.400',
      ':hover': { borderColor: 'brand.text.muted' },
      ':focus': { borderColor: 'accent.400', borderWidth: '2px' },
    },
  },
  sizes: {},
  variants: {
    rsradio: {
      focusBorderColor: 'accent.400',
      background: 'transparent',
      borderColor: 'brand.border',
      borderWidth: '1px',
      ':focus': { borderColor: 'accent.400', borderWidth: '2px' },
    },
  },
  defaultProps: {
    colorScheme: 'accent',
    iconColor: 'white',
    color: 'brand.text',
    borderColor: 'brand.border',
    paddingTop: 8,
    size: 'lg',
    focusBorderColor: 'accent.400',
  },
};
